import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

export default function LegalNoticePage() {
  return (
    <div style={{ 
      position: 'relative', 
      zIndex: 1, 
      paddingTop: '100px',
      paddingBottom: '80px',
      minHeight: '100vh',
      background: '#0a1628',
    }}>
      <div style={{ maxWidth: '720px', margin: '0 auto', padding: '0 24px' }}>
        <Link
          to="/"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            color: 'var(--vvs-muted)',
            textDecoration: 'none',
            fontSize: '11px',
            letterSpacing: '0.15em',
            textTransform: 'uppercase',
            fontFamily: 'Space Grotesk',
            marginBottom: '40px',
            transition: 'color 0.3s',
          }}
          onMouseEnter={e => e.currentTarget.style.color = '#F0F4F8'}
          onMouseLeave={e => e.currentTarget.style.color = 'var(--vvs-muted)'}
        >
          <ChevronLeft size={14} /> Home
        </Link>

        <h1 style={{
          fontFamily: 'Syne, sans-serif',
          fontWeight: 800,
          fontSize: 'clamp(32px, 6vw, 48px)',
          textTransform: 'uppercase',
          color: '#F0F4F8',
          marginBottom: '48px',
          letterSpacing: '-0.02em',
        }}>
          Legal Notice
        </h1>

        <div style={{ color: '#F0F4F8', fontFamily: 'Space Grotesk, sans-serif', fontSize: '14px', lineHeight: 1.9 }}>
          <Section title="Website operator">
            <p>Vague Vision Sound ASBL</p>
            <p>Rue du Trône 214/7</p>
            <p>1050 Ixelles, Brussels</p>
            <p>Belgium</p>
            <br />
            <p>Enterprise number: BE1019412986</p>
            <p>VAT: BE1019412986</p>
            <p>contact@vaguevisionsound.com</p>
            <p>vaguevisionsound.com</p>
            <br />
            <p style={{ color: 'var(--vvs-muted)' }}>
              Vague Vision Sound is a non-profit association (ASBL) incorporated under Belgian law (Code des sociétés et des associations).
            </p>
          </Section>

          <Section title="Hosting">
            <p>This website is hosted by Emergent (emergent.sh)</p>
          </Section>

          <Section title="Intellectual Property">
            <p style={{ color: 'var(--vvs-muted)' }}>
              All content published on this website is protected by copyright and applicable intellectual property law. Any reproduction, distribution, or commercial use without prior written authorization from Vague Vision Sound ASBL is prohibited, subject to applicable legal exceptions.
            </p>
          </Section>

          <Section title="Applicable Law">
            <p style={{ color: 'var(--vvs-muted)' }}>
              This website is subject to Belgian law. Any dispute relating to its use shall be handled by the competent courts under Belgian law, to the extent permitted by applicable consumer protection rules.
            </p>
          </Section>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: '40px' }}>
      <h2 style={{
        fontFamily: 'Syne, sans-serif',
        fontWeight: 700,
        fontSize: '16px',
        textTransform: 'uppercase',
        color: 'var(--vvs-cyan)',
        marginBottom: '16px',
        letterSpacing: '0.08em',
      }}>
        {title}
      </h2>
      {children}
    </div>
  );
}
